import { Controller } from "@hotwired/stimulus"
import "bootstrap";

export default class extends Controller {
   connect() {
      const container$ = $(this.element).carousel({
         interval: false,
         wrap: false
      });

      // update counter in image carousel
      container$.on('slide.bs.carousel', function (evt) {
         const $counter = $(this).find(".images-counter");
         const counterValue = $counter.text().split("/");
         counterValue[0] = evt.to + 1;
         $counter.text(counterValue.join("/"));
      });
   }

   gotoImage(imageId) {
      $(this.element).carousel(imageId);
   }
}
